import { Api } from "./api"

const PATH = 'abonnement'
const ENDPOINTS = {
    Liste: 'liste',
    Show: 'show',
    Historique: 'historique',
    Delete: 'delete',
    Activate: 'activate',
}

const getAbonnements = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getAbonnementDetails = (id, signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const getHistorique = (userId, signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Historique}/${userId}`, signal)
}

const deleteAbonnement = (id, signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const activateAbonnement = (id, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Activate}/${id}`, '', signal)
}

export const AbonnementApi = {
    getAbonnements,
    getAbonnementDetails,
    getHistorique,
    deleteAbonnement,
    activateAbonnement,
}
